import { extractDatePart } from "./dateParts";

function compareValues(a, b, operator) {

  const aNum = Number(a);
  const bNum = Number(b);
  const bothNumeric = a !== null && a !== "" && !isNaN(aNum) && !isNaN(bNum);

  switch (operator) {

    case ">":
      return bothNumeric ? aNum > bNum : String(a) > String(b);

    case "<":
      return bothNumeric ? aNum < bNum : String(a) < String(b);

    case ">=":
      return bothNumeric ? aNum >= bNum : String(a) >= String(b);

    case "<=":
      return bothNumeric ? aNum <= bNum : String(a) <= String(b);

    case "contains":
      return String(a ?? "").toLowerCase().includes(String(b ?? "").toLowerCase());

    case "=":
    default:
      return bothNumeric
        ? aNum === bNum
        : String(a ?? "").toLowerCase() === String(b ?? "").toLowerCase();
  }
}

// filters: [{ column, operator, value, datePart? }]
// datePart ("year"|"quarter"|"month"|"day") lets a filter target part of a
// full date column (e.g. filter column:"Order Date", datePart:"year",
// value:2013) instead of requiring a separate discrete Year column.
export function filterData(data, filters = []) {

  if (!Array.isArray(data) || !data.length) {
    return [];
  }

  if (!filters.length) {
    return data;
  }

  return data.filter(row => {

    return filters.every(filter => {

      let rowValue = row[filter.column];

      if (filter.datePart) {
        rowValue = extractDatePart(rowValue, filter.datePart);
      }

      return compareValues(rowValue, filter.value, filter.operator || "=");

    });

  });

}
